import { rem } from 'polished';
import { up } from '../../../utils/Breakpoints';
import { breakpoints } from '../layout';

const formatSize = (value: any) =>
  typeof value === 'number' && value !== 0 ? rem(value) : value;

const MQ = (n: any) => {
  const bpArray = Object.keys(breakpoints).map((key) => [
    key,
    breakpoints[key],
  ]);

  const [result] = bpArray.reduce((acc, [name, size]) => {
    if (n === name) return [...acc, `@media (min-width: ${size}px)`];
    return acc;
  }, []);

  return result;
};

const MQMax = (n: any) => {
  const bpArray = Object.keys(breakpoints).map((key) => [
    key,
    breakpoints[key],
  ]);

  const [result] = bpArray.reduce((acc, [name, size]) => {
    if (n === name) return [...acc, `@media (max-width: ${size - 1}px)`];
    return acc;
  }, []);

  return result;
};

const responsiveStyles = (props: any) => {
  let style = ``;

  Object.keys(breakpoints).forEach((breakpoint) => {
    let breakpointStyle = '';

    Object.keys(props).forEach((prop) => {
      const valuesOrValue = props[prop];
      let value;

      if (Array.isArray(valuesOrValue)) {
        // array with single value that should be carried for all breakpoints
        [value] = valuesOrValue;
      } else if (typeof valuesOrValue === 'object') {
        // object with breakpoint:value pairs
        value = valuesOrValue[breakpoint];
      } else if (breakpoint === 'zero') {
        // single value that should be applied without any media queries
        value = valuesOrValue;
      }

      if (typeof value !== 'undefined') {
        breakpointStyle += `${prop}: ${formatSize(value)};`;
      }
    });

    if (breakpointStyle) {
      if (breakpoint === 'zero') {
        style += breakpointStyle;
      } else {
        style += `
				${up(breakpoint)} { ${breakpointStyle} }`;
      }
    }
  });

  return style;
};

const listReset = 'list-style: none; margin: 0; padding: 0;';

const buttonReset =
  'background: transparent; border: none; margin: 0; padding: 0; overflow: visible; color: inherit; font: inherit; text-align: left; -webkit-font-smoothing: inherit; -moz-osx-font-smoothing: inherit; -webkit-appearance: none;';

const visuallyHidden =
  'position: absolute; overflow: hidden; clip: rect(0 0 0 0); width: 1px; height: 1px; margin: -1px; padding: 0; border: 0;';

const mixins = {
  responsiveStyles,
  listReset,
  buttonReset,
  fakeFocus: null,
  visuallyHidden,
  MQ,
  MQMax,
};

export default mixins;
